import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd';
import * as _ from 'lodash';
import { UserService } from '../../../../core/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
    selector: 'app-user-ent',
    templateUrl: './userEnt.component.html',
    styleUrls: ['./userEnt.component.css']
})
export class UserEntComponent implements OnInit {
    options: Array<any>;
    showSelect = false;
    showModal = false;

    _selectedOption: string;
    set selectedOption(value) {
        this.update(value);
    }
    get selectedOption() {
        return this._selectedOption;
    }

    constructor(
        private userService: UserService,
        private modal: NzModalService,
        private translate: TranslateService,
        private auth: AuthService
    ) { }

    ngOnInit() {
        this.userService.getUserEntList().toPromise().then(res => {
            this.options = res.listdata;
            this._selectedOption = res.value;
            sessionStorage.setItem('ent', res.value);

            // 不存在则抛异常提示
            if (res.listdata.length === 0) {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: '用户无访问数据权限，请联系管理员！',
                    okText: this.translate.instant('common.ok'),
                    onOk: () => {
                        this.auth.logout();
                    }
                });
                this.auth.logout();
            } else if (!_.some(res.listdata, x => x.ent === res.value)) {
                this.showModal = true;
            } else {
                this.showSelect = true;
            }
        });
    }

    update(value) {
        const tmp = this._selectedOption;
        this._selectedOption = value;
        sessionStorage.setItem('ent', value);
        this.userService.updateUserEnt(value)
            .subscribe(res => {
                if (!res) {
                    this._selectedOption = tmp;
                    sessionStorage.setItem('ent', tmp);
                }
            }, err => {
                this._selectedOption = tmp;
                sessionStorage.setItem('ent', tmp);
            });
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/userEnt/userEnt.component.ts